import { render } from "./ClientSpaceAccountSuccess.vue?vue&type=template&id=019f894a&scoped=true"
import script from "./ClientSpaceAccountSuccess.vue?vue&type=script&lang=js"
export * from "./ClientSpaceAccountSuccess.vue?vue&type=script&lang=js"

import "./custom-clientSpace.scss?vue&type=style&index=0&id=019f894a&lang=scss&scoped=true"
import "./custom-clientSpaceAccount.scss?vue&type=style&index=1&id=019f894a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019f894a"]])

export default __exports__